{
  "common": {
    "appName": "TrasaFlow",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "close": "Close",
    "retry": "Try again",
    "loading": "Loading …",
    "back": "Back",
    "yes": "Yes",
    "no": "No",
    "all": "All",
    "reset": "Reset",
    "notAvailableYet": "Not available yet",
    "required": "Required",
    "none": "–"
  },
  "a11y": {
    "skipToContent": "Skip to content",
    "mainNav": "Main navigation",
    "openMenu": "Open menu",
    "menuTitle": "Navigation"
  },
  "header": {
    "organization": "Organisation",
    "user": "Signed-in user",
    "language": "Language",
    "logout": "Sign out",
    "passkey": "Set up passkey",
    "userMenu": "User menu"
  },
  "language": {
    "hr": "Hrvatski",
    "de": "Deutsch",
    "en": "English"
  },
  "orgKind": {
    "GC": "General contractor",
    "CLIENT": "Client",
    "SUB": "Subcontractor"
  },
  "nav": {
    "tasks": "My tasks",
    "inbox": "Inbox",
    "orders": "Orders",
    "map": "Map",
    "calendar": "Calendar",
    "review": "Review",
    "pits": "Pits",
    "deadlines": "Deadlines",
    "crews": "Crews",
    "users": "Users",
    "dashboard": "Dashboard",
    "formsPreview": "Form preview",
    "imports": "OTW import",
    "forms": "Forms",
    "areas": "Areas",
    "dispatch": "Weekly plan",
    "permits": "Permits"
  },
  "pages": {
    "tasks": {
      "title": "My tasks",
      "description": "Everything that needs a decision or action from you today.",
      "emptyTitle": "No open tasks",
      "emptyBody": "Assigned orders, due reviews and critical deadlines will appear here."
    },
    "map": {
      "title": "Map",
      "description": "Orders, pits and crews on the map.",
      "emptyTitle": "The map is being prepared",
      "emptyBody": "Order and pit locations will appear here once the map view is connected."
    },
    "calendar": {
      "title": "Calendar",
      "description": "Dispatching of crews and appointments.",
      "emptyTitle": "No appointments",
      "emptyBody": "Scheduled orders and crew assignments will appear here. Blocks such as open pits or missing permits are flagged directly."
    },
    "review": {
      "title": "Review",
      "description": "Photos, hours and “off-site” reports awaiting approval.",
      "emptyTitle": "Nothing to review",
      "emptyBody": "Completed work steps and conspicuous evidence land in the review queue here."
    },
    "pits": {
      "title": "Pits",
      "description": "Open, provisionally closed and finished excavation pits.",
      "emptyTitle": "No pits recorded",
      "emptyBody": "Pits from the civil-works forms will appear here with their state, map and filters."
    },
    "deadlines": {
      "title": "Deadlines",
      "description": "Upcoming and expired deadlines with warning levels.",
      "emptyTitle": "No deadlines",
      "emptyBody": "Deadlines for orders and permits will be shown here with the responsible person and acknowledgement status."
    },
    "crews": {
      "title": "Crews",
      "description": "Manage the crews of your company.",
      "emptyTitle": "No crews yet",
      "emptyBody": "Create crews so that orders and work steps can be assigned."
    },
    "users": {
      "title": "Users",
      "description": "Users and roles of your organisation.",
      "emptyTitle": "No other users",
      "emptyBody": "Invited users and their roles will appear here."
    },
    "dashboard": {
      "title": "Dashboard",
      "description": "Overview of orders, deadlines and progress (read-only access).",
      "emptyTitle": "No figures yet",
      "emptyBody": "Once orders exist, you will see status, deadlines and completion at a glance."
    },
    "permits": {
      "title": "Permits",
      "description": "Application mailbox: authority messages not assigned to an application. Edit applications themselves on the order."
    }
  },
  "login": {
    "title": "Sign in to TrasaFlow",
    "intro": "Sign-in is handled by your organisation's central login service.",
    "button": "Sign in",
    "loggedOut": "You have been signed out.",
    "expired": "Your session has expired. Please sign in again.",
    "error": "Sign-in failed."
  },
  "authCallback": {
    "working": "Completing sign-in …",
    "errorTitle": "Sign-in failed",
    "errorBody": "The login service did not confirm the sign-in. Please try again."
  },
  "meError": {
    "title": "Your account could not be loaded",
    "body": "The user data is currently unreachable. Try again or sign out.",
    "forbidden": "No access has been set up for your account in TrasaFlow. Please contact your administration."
  },
  "notFound": {
    "title": "Page not found",
    "body": "This address does not exist.",
    "home": "Go to start page"
  },
  "forbidden": {
    "title": "No access",
    "body": "You lack the permission required for this page."
  },
  "errors": {
    "generic": "Something went wrong.",
    "http": "The server reported an error ({{status}}).",
    "network": "No connection to the server.",
    "notConnectedTitle": "Not connected yet",
    "notConnectedBody": "The backend does not provide this data yet. It will appear here once the endpoint is available."
  },
  "filters": {
    "title": "Filters",
    "max": "At most {{count}} filters per list"
  },
  "orders": {
    "title": "Orders",
    "description": "Orders of your organisation.",
    "filterStatus": "Status",
    "filterSearch": "Search",
    "searchPlaceholder": "Number, address or reference",
    "colNumber": "Order",
    "colStatus": "Status",
    "colAddress": "Address",
    "colDeadline": "Next deadline",
    "emptyTitle": "No orders",
    "emptyBody": "There are no orders for these filters.",
    "unavailableTitle": "Order list not connected yet",
    "unavailableBody": "The server does not provide the order list yet. It will appear here as soon as it is available.",
    "listLabel": "Order list",
    "filterOrderType": "Order type",
    "filterArea": "Area",
    "filterSub": "Subcontractor",
    "filterAmpel": "Deadline status",
    "groupBy": "Group areas by",
    "areasTitle": "Areas",
    "areaName": "Area",
    "areaOpen": "Open",
    "areaTotal": "Total",
    "areaNext": "Next deadline",
    "areaPits": "Open pits",
    "areaFilter": "Show orders",
    "areaNone": "(no area)",
    "colType": "Type",
    "colArea": "Area",
    "colAssigned": "Sub",
    "selectAll": "Select all loaded orders",
    "selectRow": "Select order {{number}}",
    "selectedCount": "{{count}} selected",
    "loadMore": "Load more",
    "loadedCount": "{{count}} orders loaded",
    "allLoaded": "All orders loaded",
    "subShort": "Sub {{id}}",
    "noSub": "no sub",
    "groupByValue": {
      "rajon": "Rajon",
      "municipality": "Municipality",
      "postal_code": "Postal code",
      "mdf": "MDF"
    }
  },
  "order": {
    "back": "Back to order list",
    "unavailableTitle": "Order not available",
    "unavailableBody": "This order does not exist, is not visible to you, or the detail view is not connected yet.",
    "number": "Order number",
    "externalRef": "Client reference",
    "status": "Status",
    "clientStatus": "Status at client",
    "address": "Address",
    "region": "Region",
    "nextDeadline": "Next deadline",
    "version": "Version",
    "actions": "Order actions",
    "noActions": "No actions are possible for you in this state.",
    "blockers": "This prevents the action",
    "done": "Action “{{action}}” executed.",
    "type": "Order type",
    "area": "Area",
    "nearbyTitle": "Nearby",
    "nearbyRadius": "Radius",
    "nearbyEmpty": "No open orders nearby.",
    "nearbyError": "Nearby orders could not be loaded.",
    "distance": "{{m}} m",
    "stepsTitle": "Work steps",
    "stepsEmpty": "No work steps yet.",
    "deadlinesTitle": "Deadlines",
    "deadlinesEmpty": "No deadlines.",
    "crewTitle": "Crew",
    "actionDue": "Action deadline",
    "notFoundTitle": "Order not found",
    "notFoundBody": "This order does not exist or is not visible to you.",
    "stepStatus": {
      "OPEN": "Open",
      "IN_PROGRESS": "In progress",
      "DONE": "Done",
      "NEEDS_FOLLOWUP": "Follow-up needed",
      "BLOCKED": "Blocked",
      "NOT_APPLICABLE": "Not applicable"
    },
    "deadlineState": {
      "OPEN": "Open",
      "EXTENDED": "Extended",
      "OVERDUE": "Action deadline passed",
      "EXPIRED": "Expired",
      "DONE": "Done",
      "CANCELLED": "Cancelled"
    },
    "reschedule": "Reschedule",
    "subCrew": "Subcontractor crew (optional)",
    "assignSub": "Subcontractor",
    "tabs": "Order views",
    "tab": {
      "details": "Details",
      "history": "History"
    }
  },
  "orderStatus": {
    "NEW": "New",
    "CLASSIFIED": "Classified",
    "ASSIGNED": "Assigned",
    "ACCEPTED": "Accepted",
    "SCHEDULED": "Scheduled",
    "IN_PROGRESS": "In progress",
    "BLOCKED": "Blocked",
    "COMPLETION_REPORTED": "Completion reported",
    "GC_APPROVED": "Approved by GC",
    "REPORTED_TO_CLIENT": "Reported to client",
    "CLIENT_ACCEPTED": "Accepted by client",
    "BILLED": "Billed",
    "CANCELLED": "Cancelled"
  },
  "orderAction": {
    "CLASSIFY": "Classify",
    "ASSIGN": "Assign",
    "HAND_OVER": "Hand over",
    "ACCEPT": "Accept",
    "REJECT": "Reject",
    "SCHEDULE": "Schedule",
    "START": "Start",
    "BLOCK": "Block",
    "UNBLOCK": "Remove block",
    "REPORT_COMPLETION": "Report completion",
    "APPROVE": "Approve",
    "RETURN_FOR_REWORK": "Return for rework",
    "REPORT_TO_CLIENT": "Report to client",
    "RECORD_CLIENT_ACCEPTANCE": "Record acceptance",
    "MARK_BILLED": "Mark as billed",
    "CANCEL": "Cancel order"
  },
  "confirm": {
    "title": "Confirm “{{action}}”?",
    "description": "The action is executed immediately.",
    "irreversibleTitle": "“{{action}}” cannot be undone",
    "irreversibleDescription": "This action cannot be reversed. Please give a reason; it is recorded in the audit log.",
    "reasonLabel": "Reason",
    "reasonHint": "At least {{count}} characters",
    "reasonTooShort": "The reason is too short.",
    "pending": "Running …",
    "failed": "The action was not executed."
  },
  "inbox": {
    "title": "Inbox",
    "description": "Deadline warnings, escalations, assignments and sync conflicts.",
    "emptyTitle": "All done",
    "emptyBody": "There are no messages for you.",
    "unavailableTitle": "Inbox not connected yet",
    "unavailableBody": "The server does not provide the inbox yet. Mandatory notices will appear here later and at the top of every page.",
    "stateLabel": "Show",
    "state": {
      "open": "Open",
      "acknowledged": "Acknowledged",
      "all": "All"
    },
    "kind": {
      "DEADLINE_WARNING": "Deadline warning",
      "DEADLINE_EXPIRED": "Deadline expired",
      "ESCALATION": "Escalation",
      "SYNC_CONFLICT": "Sync conflict",
      "ASSIGNMENT": "Assignment",
      "PERMIT": "Permit",
      "SYSTEM": "System"
    },
    "severity": {
      "INFO": "Information",
      "WARNING": "Warning",
      "CRITICAL": "Critical"
    },
    "acknowledge": "Acknowledge",
    "acknowledging": "Acknowledging …",
    "ackFailed": "Acknowledgement failed. Please try again.",
    "goToAction": "Go to action",
    "mandatoryTitle": "Mandatory notice: acknowledgement required",
    "mandatoryRegion": "Mandatory notices",
    "ackDue": "Acknowledge by {{date}}",
    "acknowledgedAt": "Acknowledged on {{date}}",
    "listLabel": "Messages",
    "mandatoryCount": "{{count}} mandatory notice(s) awaiting acknowledgement"
  },
  "forms": {
    "previewTitle": "Form preview",
    "previewDescription": "Shows form definitions as the field app evaluates them. Nothing is saved.",
    "selectForm": "Form",
    "version": "Version {{version}}",
    "formArea": "Form",
    "resultArea": "Evaluation",
    "outcome": "Outcome",
    "noOutcome": "No outcome yet (required fields missing or values invalid)",
    "stepStatus": "Step status",
    "pitState": "Pit state",
    "pitDetails": "Missing surface",
    "followUps": "Follow-up steps",
    "missingFields": "Missing required fields",
    "invalidFields": "Invalid values",
    "visibleCount": "Visible fields: {{count}}",
    "none": "none",
    "clearAnswers": "Clear answers",
    "validate": "Check inputs",
    "choose": "Please choose",
    "errorMissing": "Required",
    "errorInvalid": "Invalid value",
    "photoAdd": "Choose files",
    "photoNote": "Preview: photos are not uploaded here, only counted. At least {{min}}.",
    "photoNoteMax": "At least {{min}}, at most {{max}}.",
    "photoCount": "{{count}} file(s) chosen",
    "photoRemove": "Remove",
    "signerName": "Name of the signing person",
    "signatureToggle": "Mark signature as present",
    "pitLabel": "Joint designation or pit name",
    "unsupported": "This field type is not shown in the web preview.",
    "geometryNote": "Geometry is captured in the field app.",
    "noPermission": "The permission for the form preview is missing.",
    "stepStatusValue": {
      "DONE": "Done",
      "NEEDS_FOLLOWUP": "Follow-up needed",
      "IN_PROGRESS": "In progress",
      "BLOCKED": "Blocked"
    },
    "pitStateValue": {
      "offen": "Open",
      "provisorisch": "Provisionally closed",
      "fertig": "Finished"
    },
    "pitDetailValue": {
      "asphalt_fehlt": "Asphalt missing",
      "pflaster_fehlt": "Paving missing"
    }
  },
  "bundle": {
    "action": "Assign as daily bundle",
    "title": "Assign daily bundle",
    "description": "{{count}} orders will be assigned and bundled for the chosen day. If one order cannot be bundled, nothing changes.",
    "day": "Day",
    "done": "Daily bundle for {{day}} created with {{count}} orders.",
    "target": "Crew or subcontractor",
    "ASSIGNEE_WITHOUT_PRICE_LIST": "no price list",
    "crewOption": "Own crew",
    "subOption": "Subcontractor",
    "targetsUnavailable": "The list of crews and subcontractors is not available. Please try again later."
  },
  "ampel": {
    "red": "Overdue",
    "amber": "Due within 3 days",
    "green": "On track",
    "none": "No deadline",
    "done": "Done"
  },
  "map": {
    "listTitle": "Orders on the map ({{count}})",
    "truncated": "Only the first {{count}} orders are shown. Please narrow the filters.",
    "canvasLabel": "Map of orders. The same orders are listed below.",
    "legend": "Deadline status",
    "noLocation": "{{count}} orders without a location are not on the map but in the list.",
    "error": "The map could not be loaded.",
    "loadError": "Orders could not be loaded.",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "resetNorth": "Reset bearing to north"
  },
  "imports": {
    "title": "OTW import",
    "description": "Upload or paste the OTW list, review the preview and apply it with one click.",
    "clientId": "Client",
    "clientIdHint": "The client whose OTW list is imported.",
    "file": "File (XLSX, CSV or TSV)",
    "paste": "Or paste TSV",
    "pasteHint": "Header and rows from OTW, separated by tabs.",
    "preview": "Create preview",
    "previewing": "Creating preview …",
    "noInput": "Choose a file or paste TSV.",
    "summaryTitle": "Preview result",
    "source": "Source",
    "rowsTitle": "Rows",
    "outcomeFilter": "Show outcome",
    "colRow": "Row",
    "colRef": "Reference",
    "colOutcome": "Outcome",
    "colChanges": "Changes",
    "emptyRows": "No rows for this filter.",
    "outcome": {
      "NEW": "New",
      "CHANGED": "Changed",
      "UNCHANGED": "Unchanged",
      "INVALID": "Invalid",
      "MISSING": "Missing in list"
    },
    "diff": "{{field}}: {{from}} → {{to}}",
    "commit": "Apply",
    "commitDescription": "{{new}} new and {{changed}} changed orders will be applied. {{missing}} orders are missing from the list and are cancellation candidates.",
    "committed": "Import applied: {{new}} new, {{changed}} changed.",
    "viewOrders": "Go to orders",
    "statusCommitted": "Applied",
    "statusPreviewed": "Preview"
  },
  "deadlines": {
    "filterType": "Type",
    "filterResponsible": "Responsible",
    "filterArea": "Area",
    "filterAmpel": "Status light",
    "filterState": "State",
    "colAmpel": "Status",
    "colType": "Type",
    "colOrder": "Order",
    "colArea": "Area",
    "colActionDue": "Action deadline",
    "colDue": "Expiry",
    "colResponsible": "Responsible",
    "colState": "State",
    "colAck": "Acknowledgement",
    "colEscalation": "Escalation",
    "listLabel": "Deadline list",
    "emptyTitle": "No deadlines",
    "emptyBody": "There are no deadlines for these filters.",
    "me": "Me",
    "userShort": "User {{id}}",
    "ackNone": "No notice",
    "ackOpen": "Open, until {{date}}",
    "ackDone": "Acknowledged on {{date}}",
    "escalationNone": "none",
    "escalationLevel": "Level {{count}}",
    "loadError": "Deadlines could not be loaded.",
    "kind": {
      "ACCEPTANCE": "Acceptance",
      "ORDER_ACCEPTANCE": "Acceptance",
      "VAO": "VAO",
      "PERMIT_VALIDITY": "Permit valid until",
      "CLIENT_SLA": "Client deadline",
      "CLIENT_DEADLINE": "Client deadline",
      "CLIENT_SERVICE_TIME": "Client service time"
    }
  },
  "calendar": {
    "viewDay": "Day",
    "viewWeek": "Week",
    "viewMonth": "Month",
    "viewList": "List",
    "today": "Today",
    "calendarLabel": "Deadline calendar",
    "actionDue": "Action deadline",
    "due": "Expiry",
    "permitExpiry": "Permit expires",
    "icalTitle": "Calendar subscription (iCal)",
    "icalNote": "The subscription link will appear here once the backend provides it.",
    "legend": "Legend",
    "loadError": "The calendar could not be loaded.",
    "prev": "Previous",
    "next": "Next",
    "appointment": "Appointment",
    "icalCreate": "Create subscription link",
    "icalRotate": "Create new link",
    "icalExists": "A subscription link exists. For security it is only shown when created. A new link invalidates the old one.",
    "icalLink": "Subscription link (shown once, copy into your calendar)",
    "icalError": "The subscription link could not be created."
  },
  "dashboard": {
    "kpiTotal": "Orders in total",
    "kpiOpen": "Open",
    "kpiDone": "Completed",
    "kpiOverdue": "Overdue deadlines",
    "kpiRate": "Completed in %",
    "statusChartTitle": "Orders by stage",
    "typeChartTitle": "Orders by order type",
    "funnelTitle": "Throughput: how far have orders come?",
    "upcomingTitle": "Next deadlines",
    "docTitle": "Documentation progress per order",
    "docProgress": "{{done}} of {{total}} steps done",
    "docNone": "No running orders with work steps.",
    "dataTable": "Data as table",
    "colLabel": "Label",
    "colCount": "Count",
    "colReached": "Reached (at least)",
    "noData": "No orders yet.",
    "readOnlyNote": "Read-only access. Prices are not shown here.",
    "chartSummary": "{{title}}: {{items}}",
    "loadError": "Figures could not be loaded.",
    "upcomingNone": "No upcoming deadlines.",
    "orders": "Orders",
    "stage": {
      "intake": "Intake",
      "dispatch": "Dispatch",
      "work": "Execution",
      "review": "Review",
      "client": "Client",
      "billing": "Billing",
      "cancelled": "Cancelled"
    },
    "noType": "no type",
    "acceptanceTitle": "Reported for acceptance",
    "acceptanceNone": "No orders are waiting for your acceptance.",
    "acceptanceSince": "Reported on {{date}}",
    "acceptanceHint": "Orders the general contractor has reported to you as finished. You communicate your acceptance to the contractor.",
    "acceptanceList": "List of orders awaiting acceptance"
  },
  "files": {
    "title": "Files",
    "empty": "No verified files yet.",
    "enlarge": "Enlarge",
    "lightboxTitle": "File {{name}}",
    "close": "Close",
    "prev": "Previous file",
    "next": "Next file",
    "download": "Open original",
    "time": "Captured at",
    "gps": "GPS",
    "device": "Device",
    "hash": "Checksum (SHA-256)",
    "status": "Status",
    "category": "Category",
    "size": "Size",
    "noGps": "no GPS fix",
    "none": "not specified",
    "document": "Document",
    "noPreview": "No preview",
    "rejectedTitle": "File rejected",
    "rejectedBody": "This file was not accepted. Reason: {{reason}}",
    "loadError": "Files could not be loaded.",
    "downloadError": "The original could not be loaded.",
    "counter": "File {{index}} of {{total}}",
    "photo": "Photo",
    "statusValue": {
      "PENDING_UPLOAD": "Upload pending",
      "VERIFYING": "Being verified",
      "VERIFIED": "Verified",
      "REJECTED": "Rejected"
    },
    "rejectReason": {
      "HASH_MISMATCH": "Checksum mismatch",
      "SIZE_MISMATCH": "Size mismatch",
      "MALWARE": "Malware detected",
      "UNSUPPORTED_TYPE": "File type not supported"
    },
    "createdBy": "Captured by",
    "appVersion": "App version"
  },
  "formsAdmin": {
    "title": "Forms",
    "description": "Load, edit, evaluate on the server and publish form definitions.",
    "loadTitle": "Load version",
    "keyLabel": "Key",
    "versionLabel": "Version",
    "load": "Load",
    "known": "Known forms",
    "statusValue": {
      "DRAFT": "Draft",
      "PUBLISHED": "Published",
      "RETIRED": "Retired"
    },
    "editorLabel": "Form definition (JSON)",
    "readOnlyNote": "Published versions are immutable. Create a new version to make changes.",
    "newVersion": "Edit as new version",
    "newForm": "New form from template",
    "jsonError": "Not valid JSON: {{message}}",
    "schemaOk": "Schema valid",
    "schemaErrors": "Schema violations ({{count}})",
    "saveDraft": "Save draft",
    "saved": "Draft {{key}} v{{version}} saved.",
    "evaluate": "Evaluate on server",
    "evaluating": "Evaluating …",
    "serverResult": "Server evaluation",
    "drift": "Browser and server differ: {{fields}}",
    "noDrift": "Browser and server agree.",
    "publish": "Publish",
    "publishDescription": "Published versions are immutable and are pinned by work steps. Any later change needs a new version.",
    "published": "Version {{version}} of {{key}} published.",
    "preview": "Preview",
    "previewHint": "The preview appears once the definition is valid.",
    "violations": "The server rejects the definition",
    "unsavedChanges": "Unsaved changes: save first, then publish.",
    "referencePreview": "View reference forms",
    "loadFailed": "This version does not exist or is not visible to you.",
    "saveFailed": "The draft was not saved.",
    "current": "Loaded: {{key}} v{{version}}",
    "notLoaded": "No definition loaded yet.",
    "versionMismatch": "Version in the JSON ({{json}}) differs from the loaded version ({{loaded}}).",
    "serverNoDefinition": "Load or enter a valid definition before evaluating.",
    "actions": "Form actions",
    "colForm": "Form",
    "colStatus": "Status",
    "colPublished": "Published on"
  },
  "passkey": {
    "title": "Sign in faster with fingerprint or Face ID",
    "body": "With a passkey, your fingerprint or face replaces the password. Setup takes a minute and is always available in the user menu.",
    "setup": "Set up now",
    "later": "Later"
  },
  "review": {
    "openCount": "{{count}} items awaiting review",
    "filterKind": "Kind",
    "filterFlag": "Reason",
    "filterArea": "Area",
    "listLabel": "Review items",
    "emptyTitle": "Nothing to review",
    "emptyBody": "There are no open review items for these filters.",
    "loadError": "The review queue could not be loaded.",
    "kind": {
      "VISIT": "Visit",
      "PHOTO": "Photo",
      "MEASUREMENT": "Measurement"
    },
    "flag": {
      "backdated": "Backdated",
      "photo_time_implausible": "Photo time implausible",
      "open_too_long": "Open too long",
      "off_site": "Away from site",
      "no_fix": "No GPS fix",
      "clock_skew": "Clock deviates",
      "capped": "Hours capped",
      "joined_later": "Joined later",
      "departure_missing": "Departure missing",
      "rejected": "Rejected",
      "hash_mismatch": "Checksum mismatch",
      "malware": "Malware",
      "measurement_submitted": "Awaiting approval"
    },
    "org": "Recorded by",
    "created": "Received",
    "arrived": "Arrival",
    "departed": "Departure",
    "location": "Location",
    "clockCorrected": "Time corrected by server",
    "locationStatus": {
      "ON_SITE": "On site",
      "OFF_SITE": "Away",
      "NO_FIX": "No GPS fix"
    },
    "attendance": "Attendance",
    "colPerson": "Person",
    "colStart": "Start",
    "colEnd": "End",
    "colHours": "Hours",
    "colFlags": "Notes",
    "openEnd": "open",
    "photoCategory": "Photo category",
    "capturedAt": "Captured",
    "gpsFix": "GPS fix",
    "gpsYes": "yes",
    "gpsNo": "no",
    "rejectReason": "Rejection reason",
    "noPreview": "No preview",
    "measurementLines": "Items",
    "colPosition": "Item",
    "colQuantity": "Quantity",
    "colUnit": "Unit",
    "colNote": "Note",
    "acceptVisit": "Approve visit",
    "rejectVisit": "Reject visit",
    "acceptPhoto": "Accept photo",
    "retakePhoto": "Request retake",
    "approveMeasurement": "Approve measurement",
    "returnMeasurement": "Return measurement",
    "acceptVisitHint": "The hours of the visit are accepted.",
    "rejectVisitHint": "The hours of this visit are blocked. Review and the subcontractor see the reason.",
    "retakeHint": "The subcontractor receives a task to retake the photo.",
    "returnHint": "The measurement goes back to the subcontractor with your reason.",
    "approveHint": "The measurement is approved and can be billed.",
    "done": "Decided: {{action}}.",
    "actions": "Review item actions",
    "noRight": "You lack the permission to decide.",
    "flags": "Review reasons"
  },
  "fieldwork": {
    "title": "Field work",
    "visits": "Visits and hours",
    "visitsEmpty": "No visits yet.",
    "pits": "Pits",
    "pitsEmpty": "No pits yet.",
    "measurements": "Measurements",
    "measurementsEmpty": "No measurements yet.",
    "pitState": {
      "offen": "Open",
      "provisorisch": "Provisionally closed",
      "fertig": "Finished"
    },
    "pitDetail": {
      "asphalt_fehlt": "Asphalt missing",
      "pflaster_fehlt": "Paving missing"
    },
    "measurementStatus": {
      "SUBMITTED": "Awaiting approval",
      "APPROVED": "Approved",
      "RETURNED": "Returned"
    },
    "barrierTaken": "Barrier taken away",
    "visitOpen": "Visit open since {{date}}",
    "visitClosed": "{{from}} to {{to}}",
    "loadError": "Field work could not be loaded."
  },
  "areas": {
    "title": "Areas",
    "description": "Orders per area with open orders, deadlines and open pits, as list and on the map.",
    "listTitle": "List",
    "mapTitle": "Map",
    "mapLabel": "Map of areas. The same areas are listed next to it.",
    "showOrders": "Show orders: {{key}}",
    "bundle": "Assign daily bundle",
    "bundleFor": "Assign daily bundle: {{key}}",
    "bundleCount": "{{count}} classified orders in the area will be bundled.",
    "bundleNone": "There are no classified orders to bundle in this area.",
    "openOrders": "{{count}} open",
    "pits": "{{count}} pits open",
    "noArea": "(no area)",
    "noLocation": "Areas without a centre are not on the map but in the list.",
    "loadError": "Areas could not be loaded."
  },
  "pits": {
    "layer": "Layer",
    "layerOrders": "Orders",
    "layerPits": "Pits",
    "filterState": "Pit state",
    "filterDetail": "Missing surface",
    "listTitle": "Pits on the map ({{count}})",
    "mapLabel": "Map of pits. The same pits are listed below.",
    "empty": "No pits for these filters.",
    "loadError": "Pits could not be loaded.",
    "noLocation": "{{count}} pits without a location are not on the map but in the list.",
    "barrier": "Barrier",
    "barrierYes": "taken away",
    "barrierNo": "in place"
  },
  "dispatch": {
    "title": "Weekly plan",
    "description": "Schedule orders by dragging them onto a crew and a day. Blocks are shown before you drag.",
    "prevWeek": "Previous week",
    "nextWeek": "Next week",
    "thisWeek": "This week",
    "weekOf": "Week of {{date}}",
    "candidatesTitle": "Not scheduled",
    "candidatesHint": "Drag onto a day and a crew, or choose “Schedule …” (also by keyboard).",
    "noCandidates": "No orders to schedule.",
    "gridLabel": "Weekly plan by crew and day",
    "crewHeader": "Crew",
    "noCrews": "There are no own crews.",
    "empty": "free",
    "schedule": "Schedule …",
    "reschedule": "Reschedule …",
    "dragHint": "Drag to schedule",
    "locked": "Blocked",
    "notSchedulable": "Scheduling is currently not possible",
    "blockedDays": "Blocked on {{days}}: {{reason}}",
    "slotBlocked": "Blocked: {{reason}}",
    "dropHere": "Drop here",
    "dialogTitle": "Schedule order",
    "dialogHint": "{{number}} is scheduled for the chosen crew and day.",
    "crew": "Crew",
    "day": "Day",
    "time": "Start",
    "blockedOption": "{{label}} (blocked: {{reason}})",
    "pickCrew": "Please choose",
    "done": "{{number}} scheduled: {{day}}, {{crew}}.",
    "loadError": "The weekly plan could not be loaded.",
    "ofCrew": "{{crew}}, {{day}}",
    "blockedNow": "This target is blocked.",
    "at": "{{time}}",
    "notAcceptedYet": "Assign or accept first, then schedule"
  },
  "problem": {
    "unavailable": "The service is currently unavailable. Please try again later.",
    "stale": "The record was changed in the meantime. Please reload and try again.",
    "PERMIT_MAILBOX_UNAVAILABLE": "The application mailbox is currently unreachable. The application stays approved; send it later with “Submit”.",
    "PERMIT_MAIL_FAILED": "The e-mail to the authority could not be sent. The application stays approved; please send it again later.",
    "PERMIT_APPLICATION_INCOMPLETE": "Required details or attachments are missing: {{missing}}.",
    "PERMIT_APPLICATION_EXISTS": "An application of this permit type is already running. Use extension or new application.",
    "PERMIT_APPLICATION_NOT_DRAFT": "Only drafts can be edited or approved.",
    "PERMIT_APPLICATION_NOT_APPROVED": "Only approved applications can be submitted.",
    "PERMIT_APPLICATION_NOT_SUBMITTED": "The application has not been submitted yet.",
    "PERMIT_NOT_EXTENDABLE": "This permit cannot be extended. Please file a new application.",
    "PERMIT_NOT_GRANTED": "Only granted permits can be extended.",
    "PERMIT_PERIOD_TOO_LONG": "The authority grants at most {{maxDays}} days.",
    "PERMIT_AUTHORITY_WITHOUT_EMAIL": "No e-mail address is stored for this authority.",
    "PERMIT_CATALOG_MISSING": "The catalogue entry for this municipality and permit type is missing.",
    "PERMIT_FILE_INVALID": "The chosen file does not belong to this order or is not verified.",
    "BILLING_CHECKLIST_INCOMPLETE": "Not all checklist items are met: {{open}}. Passing requires all items; otherwise return the sheet.",
    "BILLING_REVIEW_MISSING": "The cost sheet has not been reviewed yet.",
    "BILLING_NOT_INVOICED": "No invoice has been recorded yet.",
    "COST_SHEET_LOCKED": "The cost sheet is locked and can no longer be changed.",
    "COST_SHEET_NOT_DRAFT": "Only drafts can be changed.",
    "COST_SHEET_WRONG_STATUS": "This action is not possible in the current status.",
    "MEASUREMENT_NOT_APPROVED": "The measurement has not been approved yet.",
    "PRICE_LIST_MISSING": "There is no active price list.",
    "ORDER_NOT_BILLABLE": "This order cannot be billed yet.",
    "UPLOAD_TYPE": "Only PDF, JPEG, PNG or HEIC are allowed.",
    "UPLOAD_REJECTED": "The file was rejected during checking.",
    "UPLOAD_PENDING": "The file is still being checked. Please wait a moment and choose it again.",
    "PERMIT_ATTACHMENT_INVALID": "An attachment does not belong to this order or is not verified.",
    "CREW_NAME_TAKEN": "A crew with this name already exists.",
    "USER_EMAIL_TAKEN": "This email address is already in use."
  },
  "blockerCode": {
    "ORDER_PERMIT_MISSING": "There is no valid permit.",
    "PERMIT_MISSING": "There is no valid permit.",
    "PERMIT_MISSING_AT_START": "There is no valid permit on the start date.",
    "PERMIT_CATALOG_MISSING": "The authority catalogue has no entry for this municipality. Please add one.",
    "ORDER_TYPE_UNKNOWN": "The order type is unknown. Please classify the order.",
    "CREW_SET_BY_GC": "The general contractor set the crew; it cannot be changed.",
    "CREW_ONLY_OWN_ASSIGNMENT": "A crew can only be chosen for your own assignment.",
    "CREW_NOT_EXECUTOR": "The chosen person is not allowed to carry out orders and is not a crew."
  },
  "permits": {
    "title": "Permits",
    "create": "Create application",
    "statusValid": "A valid permit exists or none is required.",
    "statusMissing": "A valid permit is missing:",
    "reason": {
      "MISSING": "There is no permit for “{{type}}”.",
      "NOT_VALID_ON_DAY": "The permit “{{type}}” is not valid on the working day.",
      "ORDER_TYPE_UNKNOWN": "The order type is unknown, so the permit requirement cannot be assessed. Please classify the order.",
      "CATALOG_MISSING": "The authority catalogue has no entry for this municipality. Please add one."
    },
    "validRange": "(valid {{from}} – {{to}})",
    "loadError": "The permits could not be loaded.",
    "empty": "No application for this order yet.",
    "history": {
      "created": "Draft created",
      "approved": "Approved for submission",
      "submitted": "Submitted",
      "decided": "Decision recorded"
    },
    "historyTitle": "History ({{count}})",
    "direction": {
      "OUT": "Outgoing",
      "IN": "Incoming"
    },
    "messageKind": {
      "APPLICATION": "Application",
      "FOLLOW_UP": "Follow-up",
      "RECEIPT": "Receipt",
      "DECISION": "Decision",
      "OTHER": "Other"
    },
    "messageStatus": {
      "SENT": "sent",
      "FAILED": "failed",
      "MATCHED": "matched",
      "UNMATCHED": "unmatched"
    },
    "status": {
      "DRAFT": "Draft",
      "APPROVED": "Approved",
      "SUBMITTED": "Submitted",
      "GRANTED": "Granted",
      "REJECTED": "Rejected",
      "WITHDRAWN": "Withdrawn",
      "SUPERSEDED": "Superseded"
    },
    "kind": {
      "NEW": "New application",
      "EXTENSION": "Extension",
      "RENEWAL": "Renewal"
    },
    "replaceReason": "Reason: {{reason}}",
    "period": "Requested period",
    "field": {
      "location_address": "Work location",
      "cadastralParcel": "Cadastral parcel",
      "trench_lengthM": "Trench length (m)",
      "trench_widthM": "Trench width (m)",
      "trench_depthM": "Trench depth (m)",
      "trafficResponsible_name": "Responsible person",
      "trafficResponsible_phone": "Responsible person phone",
      "trafficScheme": "Traffic management",
      "remarks": "Remarks"
    },
    "attachment": {
      "ROUTE_SKETCH": "Road sketch / site plan",
      "TRAFFIC_SCHEME": "Traffic sign plan",
      "ENGINEER_DECLARATION": "Engineer declaration",
      "FEE_PROOF": "Proof of fee",
      "CADASTRAL_EXTRACT": "Cadastral extract",
      "OWNER_CONSENT": "Owner consent",
      "OTHER": "Other"
    },
    "outcome": {
      "GRANTED": "Granted",
      "REJECTED": "Rejected"
    },
    "fileNumber": "File number",
    "validity": "Validity",
    "conditions": "Conditions",
    "edit": "Edit",
    "approve": "Approve",
    "submit": "Submit",
    "followUp": "Follow up",
    "decision": "Record decision",
    "extension": "Extend",
    "renewal": "New application",
    "saved": "{{number}} saved.",
    "approved": "{{number}} approved.",
    "submitted": "{{number}} submitted.",
    "followedUp": "Follow-up for {{number}} sent.",
    "decided": "Decision for {{number}} recorded.",
    "created": "{{number}} created.",
    "createHint": "The application is pre-filled from the order data. Without a period the suggested one applies.",
    "permitType": "Permit type",
    "from": "From",
    "to": "To",
    "periodHint": "The authority may limit the duration.",
    "editHint": "Complete missing details. Attachments can only come from the verified files of this order.",
    "noAttachment": "No file",
    "attachmentHint": "If a file is missing, upload it first under Files on the order.",
    "approveHint": "Checks required details and attachments. With e-mail submission the application goes to the authority immediately; nothing is sent without approval.",
    "submitHint": "The approved application is sent again or marked as submitted.",
    "followUpHint": "This enquiry goes to the authority. The next follow-up deadline moves afterwards.",
    "draftError": "The draft could not be loaded.",
    "mailTo": "To",
    "mailSubject": "Subject",
    "mailBody": "Text",
    "decisionHint": "Records the authority’s decision. If granted, the validity is monitored as a deadline.",
    "outcomeLabel": "Outcome",
    "decidedOn": "Decision dated",
    "validFrom": "Valid from",
    "validTo": "Valid until",
    "decisionFile": "Decision (PDF or image)",
    "renewalHint": "The running application is replaced. The reason is mandatory and logged.",
    "mailbox": {
      "record": "Record incoming message",
      "unmatchedTitle": "Unmatched incoming messages",
      "emptyTitle": "Everything assigned",
      "emptyBody": "There are no messages without an application. Assignment uses the application number [ANT-YYYY-NNNNN] in the subject.",
      "recordHint": "Records an incoming message manually. If the subject contains the application number [ANT-YYYY-NNNNN], it is assigned to that application.",
      "kind": "Type",
      "matched": "Message recorded and assigned to the application.",
      "unmatched": "Message recorded but not assigned to an application."
    },
    "saveDraft": "Save draft",
    "catalogEmpty": "No application type is stored in the catalog for this municipality.",
    "catalogMandatory": "Mandatory attachments",
    "catalogDays": "Typical processing time: {{days}} working days"
  },
  "billing": {
    "title": "Billing",
    "clientAmount": "Client amount",
    "subAmount": "Subcontractor amount",
    "margin": "Margin",
    "subTitle": "Subcontractor statement",
    "loadError": "The billing data could not be loaded.",
    "subNone": "No subcontractor statement yet.",
    "subStatus": {
      "DRAFT": "Draft",
      "APPROVED": "Approved"
    },
    "total": "Total",
    "col": {
      "no": "No.",
      "kind": "Type",
      "position": "Position",
      "text": "Text",
      "quantity": "Quantity",
      "unit": "Unit",
      "unitPrice": "Unit price",
      "amount": "Amount",
      "actions": "Actions"
    },
    "deviation": {
      "NOT_IN_CATALOG": "Not in service catalogue",
      "NO_PRICE": "No price"
    },
    "kind": {
      "SERVICE": "Service",
      "WORK": "Work",
      "MATERIAL": "Material"
    },
    "status": {
      "DRAFT": "Draft",
      "REVIEWED": "Reviewed",
      "RETURNED": "Returned",
      "SUBMITTED": "Transferred to IDBM",
      "CLIENT_APPROVED": "Approved by HT",
      "CLIENT_REJECTED": "Rejected by HT",
      "BILLED": "Billed"
    },
    "regenerate": "Regenerate",
    "generate": "Create cost sheet",
    "addLine": "Add line",
    "pass": "Pass review",
    "returnSheet": "Return",
    "submit": "Transfer to IDBM",
    "decision": "Record HT decision",
    "invoice": "Record invoice",
    "none": "No cost sheet yet. It is created from the approved measurement.",
    "lineDeleted": "Line deleted.",
    "showTransfer": "Show transfer view",
    "hideTransfer": "Hide transfer view",
    "generateHint": "Quantities per position are summed from the approved measurement; prices come from the active price list. Added lines are kept.",
    "generated": "Cost sheet created.",
    "lineAdded": "Line added.",
    "passed": "Review passed: cost sheet reviewed.",
    "returned": "Cost sheet returned.",
    "submitted": "Transferred to IDBM.",
    "decided": "HT decision recorded.",
    "invoiced": "Invoice recorded: billed.",
    "idbmNumber": "Number in IDBM",
    "submitHint": "Enter the number under which the cost sheet was created in IDBM.",
    "invoiceNumber": "Invoice number",
    "invoiceHint": "Afterwards “Mark as billed” is possible on the order.",
    "revision": "Revision {{revision}}",
    "flow": "Billing flow",
    "returnedBecause": "Returned: {{reason}}",
    "rejectedBecause": "Rejected by HT: {{reason}}",
    "idbmDifference": "IDBM difference {{amount}} (approved: {{approved}})",
    "idbmNumberValue": "IDBM number: {{number}}",
    "invoiceNumberValue": "Invoice: {{number}}",
    "linesLabel": "Cost sheet lines",
    "deleteLine": "Delete line {{no}}",
    "delete": "Delete",
    "transferError": "The transfer view is only available after the review has passed.",
    "transferHint": "Fields in the order of the IDBM form, without prices. Each field can be copied individually.",
    "transferLabel": "Transfer view for IDBM",
    "copyField": "Copy field: {{field}}",
    "copied": "Copied: {{field}}.",
    "downloadXlsx": "Download XLSX",
    "downloadError": "The download failed.",
    "lineHint": "Add a work or material line. Material needs the EDM number.",
    "edmNo": "EDM number",
    "warehouse": "Warehouse",
    "batch": "Batch",
    "serialNo": "Serial number",
    "checklist": "Checklist",
    "passHint": "Passing requires all checklist items. Afterwards the transfer to IDBM is possible.",
    "returnHint": "The cost sheet goes back to the subcontractor with your reason.",
    "check": {
      "measurement_matches_photos": "Measurement matches the photos",
      "documents_complete": "Documents complete",
      "positions_match_catalog": "Positions match the service catalogue",
      "materials_recorded": "Materials recorded"
    },
    "decisionHint": "HT decision from IDBM. Cost sheet: {{total}}. A rejection goes back to the subcontractor with its reason.",
    "outcome": "Decision",
    "outcomeApproved": "Approved",
    "outcomeRejected": "Rejected",
    "approvedAmount": "Approved amount",
    "rejectReason": "Reason for rejection"
  },
  "classification": {
    "suggestion": "AI classification suggestion: {{type}} ({{percent}} % confidence)",
    "hint": "Below the threshold, dispatch confirms the order type.",
    "confirm": "Confirm suggestion",
    "other": "Choose another order type",
    "confirmHint": "The order will be classified as “{{type}}”.",
    "otherHint": "Choose the order type used to classify the order.",
    "done": "Order classified as “{{type}}”.",
    "type": {
      "INSTALLATION": "Installation",
      "FAULT": "Fault",
      "RELOCATION": "Relocation",
      "DISCONNECTION": "Disconnection",
      "CIVIL_WORKS": "Civil works"
    }
  },
  "combobox": {
    "placeholder": "Select or search …",
    "empty": "No matches",
    "unavailable": "The list is not available.",
    "clear": "Clear selection",
    "noneChosen": "Nothing selected",
    "remove": "Remove: {{name}}"
  },
  "crewAdmin": {
    "create": "Add crew",
    "showInactive": "Show inactive crews",
    "loadError": "Crews could not be loaded.",
    "loadErrorBody": "Please try again later.",
    "active": "Active",
    "inactive": "Inactive",
    "edit": "Edit",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "leader": "Foreman",
    "members": "Members ({{count}})",
    "activateHint": "Crew “{{name}}” is activated again and can be chosen in dispatch.",
    "deactivateHint": "Crew “{{name}}” is deactivated and can no longer be chosen in dispatch. Existing appointments stay.",
    "activated": "Crew “{{name}}” activated.",
    "deactivated": "Crew “{{name}}” deactivated.",
    "save": "Save crew",
    "createHint": "Set a name and pick the foreman and members from the users of your organization.",
    "editHint": "Change name, foreman, members and status.",
    "name": "Name",
    "nameTaken": "A crew with this name already exists.",
    "membersLabel": "Members",
    "activeLabel": "Crew is active",
    "saved": "Crew “{{name}}” saved.",
    "created": "Crew “{{name}}” added.",
    "org": "Organization",
    "ownOrg": "Own organization"
  },
  "admin": {
    "tab": {
      "users": "Users",
      "organizations": "Organizations",
      "sites": "Sites"
    },
    "search": "Search (name or email)",
    "createUser": "Add user",
    "createUserHint": "The user receives a one-time start password or an invitation link. Both are shown only once.",
    "col": {
      "name": "Name",
      "email": "Email",
      "org": "Organization",
      "role": "Role",
      "sites": "Sites",
      "status": "Status",
      "actions": "Actions"
    },
    "editRole": "Change role",
    "editRoleHint": "Change role, sites and status of {{name}}.",
    "newOnboarding": "New start password",
    "onboardingHint": "A new one-time start password or invitation link is created for {{name}}. The previous access becomes invalid.",
    "userCreated": "User {{name}} added.",
    "userSaved": "User {{name}} saved.",
    "loadError": "The data could not be loaded.",
    "loadErrorBody": "Please try again later.",
    "secretTitle": "Access for {{name}}",
    "secretOnce": "This access is shown only now. Afterwards nobody can retrieve it, not even the administration.",
    "tempPassword": "Start password",
    "inviteLink": "Invitation link",
    "copy": "Copy",
    "copied": "Copied",
    "secretNone": "The server returned no access.",
    "validUntil": "Valid until {{date}}",
    "secretWarning": "Hand over the access in person or through a secure channel only.",
    "secretClose": "Noted, close",
    "createOrg": "Add organization",
    "createOrgHint": "Set name and kind. Add sites and users afterwards.",
    "orgCreated": "Organization {{name}} added.",
    "orgKindLabel": "Kind",
    "orgKind": {
      "GC": "General contractor (GC)",
      "SUB": "Subcontractor",
      "CLIENT": "Client"
    },
    "createSite": "Add site",
    "createSiteHint": "A site belongs to an organization and limits which orders a user sees.",
    "siteCreated": "Site {{name}} added.",
    "siteName": "Site name",
    "sitesEmptyTitle": "No sites yet",
    "sitesEmptyBody": "Add sites to limit what users can access.",
    "pickOrgFirst": "Choose an organization first.",
    "activeLabel": "User is active",
    "locale": "Language",
    "sendInvite": "Send an email invitation instead of a start password",
    "userInvited": "User {{name}} added, the invitation has been sent.",
    "saveRoles": "Save roles",
    "revoke": "Revoke",
    "revokeRole": "Revoke role: {{name}}",
    "newRole": "new",
    "addRole": "Add role",
    "scopeSite": "Limited to site (optional)",
    "allSites": "All sites",
    "addRoleButton": "Stage role",
    "profile": "Client profile",
    "siteCode": "Site code",
    "siteAddress": "Address (optional)"
  },
  "history": {
    "title": "History",
    "immutable": "Every version and event is stored immutably and chained (audit-proof). Entries can be neither changed nor deleted.",
    "noPrices": "Prices and margins are not part of your history.",
    "version": "Version {{version}}",
    "event": "Event",
    "system": "System",
    "hash": "Checksum",
    "hashHint": "Checksum of the chain; it changes with every later manipulation.",
    "changesOf": "Changes: {{summary}}",
    "col": {
      "field": "Field",
      "from": "Before",
      "to": "After"
    },
    "more": "Load older entries",
    "loadError": "The history could not be loaded.",
    "loadErrorBody": "Please try again later.",
    "emptyTitle": "No history yet",
    "emptyBody": "Versions and events of this order appear here.",
    "field": {
      "address": "Address",
      "status": "Status",
      "orderType": "Order type",
      "scheduledStart": "Appointment",
      "crew": "Crew",
      "price": "Price",
      "assigneeOrgId": "Subcontractor",
      "clientStatus": "Client status",
      "externalRef": "External reference",
      "rajon": "District",
      "municipality": "Municipality"
    },
    "action": {
      "CREATED": "Created",
      "REVISED": "Changed",
      "SUBMITTED": "Submitted",
      "STATUS_CHANGED": "Status changed",
      "SCHEDULE": "Appointment changed",
      "CREW_CHANGED": "Crew changed",
      "REQUEST_SCHEDULE": "Requested date",
      "DELETED": "Deleted"
    }
  },
  "permitFiles": {
    "title": "Attachments",
    "required": "Required",
    "requiredMissing": "This required attachment is still missing.",
    "state": {
      "missing": "Not uploaded",
      "UPLOADED": "Uploaded",
      "VERIFIED": "Verified",
      "REJECTED": "Rejected"
    },
    "upload": "Upload {{kind}}",
    "replace": "Replace {{kind}}",
    "uploading": "Uploading …",
    "saved": "Attachment “{{kind}}” saved.",
    "rejectedBody": "The file was rejected. Reason: {{reason}}",
    "rejectedUnknown": "unknown",
    "hintDraft": "Attachments can be uploaded and replaced while the application is a draft. PDF, JPEG, PNG and HEIC are allowed.",
    "hintLocked": "Attachments are locked after approval.",
    "template": "Official form templates of the municipality",
    "templateDownload": "Download {{name}}",
    "templateError": "The template could not be loaded.",
    "templateSource": "Source",
    "templateRetrieved": "retrieved on {{date}}",
    "loadError": "The attachments could not be loaded.",
    "note": "Note",
    "noteLabel": "Note on {{kind}} (optional)",
    "noteLabelOther": "Note on the next other attachment (optional)",
    "noteSave": "Save note",
    "noteSaved": "Note on “{{kind}}” saved.",
    "remove": "Remove {{kind}}",
    "removed": "Attachment “{{kind}}” removed.",
    "add": "Add {{kind}}",
    "otherItem": "File {{n}}",
    "otherCount": "Files: {{count}}"
  },
  "pitPhotos": {
    "show": "Show photos",
    "pick": "Choose a pit to see the photos of the three phases.",
    "title": "Photos of pit {{label}}",
    "missing": "Photos missing for: {{phases}}.",
    "phase": {
      "VOR_OEFFNEN": "Before opening",
      "WAEHREND_ARBEITEN": "During work",
      "NACH_SCHLIESSEN": "After closing"
    },
    "none": "No photos in this phase.",
    "notDueYet": "Not due yet: the pit is still open.",
    "photoError": "The photo could not be loaded.",
    "loadError": "The pit could not be loaded."
  },
  "search": {
    "label": "Search orders",
    "placeholder": "Search order (number, address) …",
    "hint": "Enter at least two characters",
    "none": "No order found",
    "error": "Search is currently unavailable"
  },
  "requested": {
    "set": "Set requested date",
    "clear": "Clear requested date",
    "hint": "The requested date is non-binding and does not change the status. Dispatch sets the binding appointment.",
    "clearHint": "The requested date will be removed.",
    "note": "Note (optional)",
    "past": "The requested date must be in the future.",
    "saved": "Requested date saved.",
    "cleared": "Requested date cleared.",
    "label": "Requested date",
    "noteLabel": "Note on the requested date",
    "crew": "Crew"
  }
}
